"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReducerBuilder = (function () {
    function ReducerBuilder() {
        this.cases = {};
    }
    ReducerBuilder.prototype.init = function (state) {
        this.initial = state;
        return this;
    };
    ReducerBuilder.prototype.case = function (type, reducer) {
        this.cases[type] = reducer;
        return this;
    };
    ReducerBuilder.prototype.external = function (type, reducer) {
        this.cases[type] = reducer;
        return this;
    };
    ReducerBuilder.prototype.build = function () {
        var _this = this;
        var initialAction = {
            type: '',
            payload: {}
        };
        return function (state, action) {
            if (state === void 0) { state = _this.initial; }
            if (action === void 0) { action = initialAction; }
            var handler = _this.cases[action.type];
            return handler ? handler(state, action.payload, action) : state;
        };
    };
    return ReducerBuilder;
}());
exports.ReducerBuilder = ReducerBuilder;
//# sourceMappingURL=reducer-builder.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngfk/ts-redux/dist/reducer-builder.js
// module id = 53
// module chunks = 0